import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "tabs-list" }
const _hoisted_3 = ["onClick", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tabs-container",
      style: _normalizeStyle(_ctx.widthStyle)
    }, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["tabs-tab", { isActive: tab.id === _ctx.activeTabId }]),
            key: tab.id
          }, [
            _createElementVNode("span", {
              onClick: _withModifiers(($event: any) => (_ctx.changeTab(tab)), ["prevent"]),
              tabindex: "0",
              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.changeTab(tab)), ["stop"]), ["enter"])
            }, _toDisplayString(tab.title), 41, _hoisted_3)
          ], 2))
        }), 128))
      ])
    ], 4)
  ]))
}